"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var AgencySearchList = _ref => {
  var {
    agencies,
    currentPage,
    setHoverId
  } = _ref;
  // check that response is not empty and that response contains specific agency fields
  if (!agencies || !agencies[0].agencyurl) {
    return '';
  }
  var paginatedAgencies = agencies.slice((currentPage - 1) * 10, currentPage * 10);
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "agency-search-list"
  }, paginatedAgencies.map((agency, index) => {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: index + agency.agencyname,
      onMouseOver: () => setHoverId(index)
    }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
      className: "agency-search-details"
    }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      sm: 12,
      md: 7,
      className: "agency-info-col"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "mm-media-object"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "agency-info"
    }, /*#__PURE__*/_react.default.createElement("h3", {
      className: "agency-name"
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: "btn btn-inline",
      href: agency.agencyurl
    }, agency.agencyname)), /*#__PURE__*/_react.default.createElement("h4", {
      className: "agency-office-type"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: agency.agencyurl
    }, agency.officetype)), /*#__PURE__*/_react.default.createElement("p", {
      className: "agency-address"
    }, "".concat(agency.location.addressline, " ").concat(agency.location.addresslinesextra)), /*#__PURE__*/_react.default.createElement("p", {
      className: "agency-city-state"
    }, "".concat(agency.location.city, ", ").concat(agency.location.state, " ").concat(agency.location.zip))))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      s: 12,
      md: 5
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "agency-phone"
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: "btn btn-inline",
      href: "tel:".concat(agency.location.phone)
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "icon-call"
    }), " ".concat(agency.location.phone)))))));
  }));
};
var _default = exports.default = AgencySearchList;